import { render, staticRenderFns } from "./CreationOptions.vue?vue&type=template&id=ef5ec47c&scoped=true&"
import script from "./CreationOptions.vue?vue&type=script&lang=js&"
export * from "./CreationOptions.vue?vue&type=script&lang=js&"
import style0 from "./CreationOptions.vue?vue&type=style&index=0&id=ef5ec47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ec47c",
  null
  
)

export default component.exports